import React from 'react';
import { PermissionI } from 'types';
import { CardBody, CardContainer, CardHeader, CardTitle, StyledSwitch } from './style';

interface Props {
  permission: PermissionI & { assigned: boolean };
  onChangeChecked: (id: string, status: boolean) => void;
}

export const PermissionCard = ({ permission, onChangeChecked }: Props) => {
  const checked = permission.assigned;
  return (
    <CardContainer>
      <CardHeader>
        <CardTitle>{permission.name}</CardTitle>
        <StyledSwitch
          checked={checked}
          onChange={event => onChangeChecked(permission.id, event.target.checked)}
          color="success"
        />
      </CardHeader>
      <CardBody>{permission.description}</CardBody>
    </CardContainer>
  );
};
